module.exports = __webpack_public_path__ + "img/schedule-table-icon.b0e03572.svg";